/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-10-05
 * @description Implementation of S3 utility class.
 * @filename s3.ts
 */

import { ApiClient } from "../authentication/api-client";

/**
 * A collection of utilities for AWS S3.
 */
export class MqttClient {
  static createThing(): void {}

  /**
   *
   *
   * @static
   * @param {string} text
   * @param {string} topic
   * @returns {Promise<any>}
   * @memberof MqttClient
   */
  static publishMessageOnTopic(text: string, topic: string, recordId?: string, meta?: any): Promise<any> {
    const type = "live_comment";
    const MESSAGE = {
      text,
      type,
      recordId,
      meta,
      created: new Date().getTime(),
    };

    return ApiClient.mqttPublish(JSON.stringify(MESSAGE));
  }
}
